import styled from "styled-components";

export const StyledParagraph = styled.p`
  font-family: "Rubik";
  font-weight: 100;
  font-size: var(--hero-p-fs);
  color: var(--secondary-font-color);
  letter-spacing: 1px;
  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: justify;
  word-break: break-all;
`;
